import { Reveal } from "@/components/motion/Reveal";
import { PORTFOLIO } from "@/data/content";

export default function Portfolio() {
  return (
    <section id="work" className="bg-background py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6 mb-14">
          <div>
            <span className="overline text-concrete-500">/ Recent pours</span>
            <h2 className="mt-4 font-display font-extrabold tracking-tighter text-concrete-900 text-5xl sm:text-6xl leading-[0.95]">
              The Work
            </h2>
          </div>
          <p className="max-w-sm text-concrete-600 text-base leading-relaxed">
            Real jobs, real finishes around Sydney. Hover to see the detail in full colour.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-4 auto-rows-[240px] sm:auto-rows-[300px]">
          {PORTFOLIO.map((p, i) => (
            <Reveal
              key={i}
              delay={(i % 3) * 0.07}
              className={`group relative overflow-hidden border border-black/10 ${p.span || "lg:col-span-4"}`}
            >
              <img
                src={p.src}
                alt={`${p.label} — Upscale Concrete Services Sydney`}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover scale-105 group-hover:scale-100 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-concrete-900/70 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <span className="absolute bottom-4 left-4 overline text-white translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-500">
                {p.label}
              </span>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
